import useSWR from "swr";
import { useAuthToken } from "hooks/useAuthToken";
import {
  type PromotionSelectionItem,
  getCustomerAppliedPromotions,
  getRepAppliedPromotions,
} from "services/promotions";

const promotionsFetcher = async ([
  ,
  authKey,
  isCustomer,
  prospectId,
  proposalId,
  promotionType,
]: [string, string, boolean, string, string, string]): Promise<
  PromotionSelectionItem[]
> => {
  if (isCustomer) {
    return getCustomerAppliedPromotions(
      authKey,
      proposalId,
      prospectId,
      promotionType
    );
  }
  return getRepAppliedPromotions(
    authKey,
    prospectId,
    proposalId,
    promotionType
  );
};

const useAppliedPromotions = (
  proposalId: string | undefined,
  prospectId: string | undefined,
  enabled: boolean,
  promotionType = "APPLIED"
) => {
  const hybridToken = useAuthToken("HYBRID")?.token;
  const proposalToken = useAuthToken("PROPOSAL")?.token;
  const isCustomer = Boolean(proposalToken);
  const authKey = isCustomer ? proposalToken : hybridToken;
  const shouldFetch = enabled && Boolean(proposalId && prospectId && authKey);

  const { data, error, isLoading } = useSWR(
    shouldFetch
      ? [
          isCustomer ? "Get Customer Promotions" : "Get Promotions",
          authKey!,
          isCustomer,
          prospectId!,
          proposalId!,
          promotionType,
        ]
      : null,
    promotionsFetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return {
    promotions: data ?? [],
    error,
    isLoading,
  };
};

export { useAppliedPromotions };
